import { MasonryEngine } from '@leagueplatform/masonry-engine';
import { getMasonryDriver } from '@leagueplatform/masonry';
import { CASE_MANAGEMENT_ROOT_NODE_ID } from 'common/constants';
import { MasonryPageContainer } from '../masonry-container.page';

const MasonryCaseManagementDriver = getMasonryDriver({
  rootNodeId: CASE_MANAGEMENT_ROOT_NODE_ID,
});

export const CaseManagementPage = () => (
  <MasonryPageContainer>
    <MasonryEngine driver={MasonryCaseManagementDriver} />
  </MasonryPageContainer>
);
